export const mountDevTools = (name: string, store: any) => {
	if (process.env.NODE_ENV === 'development') {
		// Using dynamic import to avoid requiring the module in production
		import('simple-zustand-devtools').then(({ mountStoreDevtool }) => {
			mountStoreDevtool(name, store);
		});
	}
};
